// extracted by mini-css-extract-plugin
module.exports = {"select":"select-module--select--tNacO","selectLabel":"select-module--select-label--1Sq0K"};